import React from "react";
import { FloatingWhatsApp } from "react-floating-whatsapp";

import { useTranslation } from "react-i18next";

const WhatsAppBox = ({ phone, logo }) => {
	const { t, i18n } = useTranslation();
	const chatMessage = () => {
		return <p>{t("default message")}</p>;
	};
	return (
		<>
			<div className='' style={{ direction: "ltr" }}>
				<FloatingWhatsApp
					accountName={t("webSite name")}
					placeholder={t("whatsApp placeholder")}
					statusMessage={t("status Message")}
					avatar={logo}
					chatMessage={chatMessage().props.children}
					allowEsc
					notification
					allowClickAway
					notificationSound
					phoneNumber={
						phone?.startsWith("+966")
							? phone?.slice(1)
							: phone?.startsWith("00966")
							? phone?.slice(2)
							: phone
					}
				/>
			</div>
		</>
	);
};

export default WhatsAppBox;
